import types from 'actions/types'

export const setTargetLanguage = (language) => ({ type: types.LANGUAGE_SET_TARGET, language })

export const translateText = (text) => ({ type: types.LANGUAGE_TRANSLATE_TEXT, text })

export const textTranslated = (languageMap) => ({ type: types.LANGUAGE_TEXT_TRANSLATED, languageMap })
